import IconRow from "../IconRow/IconRow";
import "./Footer.css";

function Footer() {
  return (
    <section className="footer">
      <a href="/" rel="noreferrer" target="_blank">
        Baller Bears
      </a>
      <IconRow />
    </section>
  );
}

export default Footer;
